import React, { useState, useEffect, useRef } from "react";
import Navbar from "../Common/Navbar";
import SideMenu from "../Common/SideMenu";
import DashboardIcon from "../../assets/icons/dashboard";
import UsersIcon from "../../assets/icons/users";
import CheckBoardIcon from "../../assets/icons/checkboard";
import ListIcon from "../../assets/icons/list";
import FolderIcon from "../../assets/icons/folder";
import CogIcon from "../../assets/icons/cog";
import DocumentIcon from "../../assets/icons/document";
import ProfileIcon from "../../assets/icons/profile";
import NotificationIcon from "../../assets/icons/notification";
import { LayoutContext } from "./LayoutContext";

const Layout = ({ children }) => {
  const layoutRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [user, setUser] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    setUser(JSON.parse(userData));
  }, []);

  const menuItems = [
    { path: "/", label: "Dashboard", Icon: DashboardIcon },
    { path: "/onboarding", label: "Onboarding", Icon: UsersIcon },
    { path: "/employees", label: "All Employee", Icon: UsersIcon },
    { path: "/attendance-log", label: "Attendance", Icon: CheckBoardIcon },
    { path: "/leave-requests", label: "Leave Requests", Icon: ListIcon },
    { path: "/payroll", label: "Payroll", Icon: FolderIcon },
    {
      path: "/requested-documents",
      label: "Requested Documents",
      Icon: DocumentIcon,
    },
    { path: "/role-management", label: "Manage Role", Icon: CogIcon },
    { path: "/grade-management", label: "Manage Grade", Icon: CogIcon },
    { path: "/holiday-management", label: "Manage Holiday", Icon: CogIcon },
    {
      path: "/designation-management",
      label: "Manage Designation",
      Icon: CogIcon,
    },
    {
      path: "/department-management",
      label: "Manage Department",
      Icon: CogIcon,
    },
    { path: "/notifications", label: "Notifications", Icon: NotificationIcon },
    { path: "/profile", label: "Profile", Icon: ProfileIcon },
  ];

  return (
    <LayoutContext.Provider
      value={{ userData: user ? user : null, layoutRef: layoutRef }}
    >
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar */}
        <div
          className={`fixed top-[88px] left-0 h-[calc(100%-88px)] bg-white border-r border-[#142b701a] transition-all duration-300 z-30
  ${isOpen ? "translate-x-0" : "-translate-x-full"} w-64 md:translate-x-0`}
        >
          <SideMenu menuItems={menuItems} />
        </div>

        {/* Main content */}
        <div className="flex flex-col flex-1 w-full">
          <div className="fixed top-0 left-0 right-0 z-30">
            <Navbar toggleSidebar={() => setIsOpen(!isOpen)} user={user} />
          </div>

          {/* Push content below navbar */}
          <main
            className={`mt-[88px] transition-all duration-300 p-6 bg-[#f9f9f9] min-h-[calc(100vh-88px)] overflow-y-scroll ${
              isOpen ? "md:ml-64" : "md:ml-16"
            }`}
            ref={layoutRef}
          >
            {children}
          </main>
        </div>
      </div>
    </LayoutContext.Provider>
  );
};

export default Layout;
